<div class="fx-row fx-wrap align-items-stretch justify-content-start border-bottom mt-8 mb-8  fx-flex-100">
  <div class="fx-flex border-box fx-flex-100 pb-16">
    <mat-card *ngIf="case && case.documents && case.type !== CaseType.RENEWAL_MAINTENANCE">
      <div class="fx-row fw-wrap align-items-center justify-content-between">
        <div class="fx-column">
          <div class="fx-row fw-wrap align-items-baseline justify-content-start">
            <app-animated-number [value]="count" [class]="'text bold main'"></app-animated-number>
            &nbsp;
            <span class="text bold"><span class="bold main">{{((count > 1 ? 'ENTITIES.PROOFS' :
                'ENTITIES.PROOF') |
                translate).toLowerCase()}}</span> {{('CASE.PROOFS_FOR_CASE' |
              translate).toLowerCase()}}</span>
          </div>
          <span class="text">{{'CASE.COVERAGE_REPORT' | translate}}</span>
        </div>
        <button class="main-button ml-10" (click)="toProofs.emit()">
          {{'TRADEMARK.VIEW_PROOFS' | translate}}
        </button>
      </div>
    </mat-card>
  </div>
</div>
<div class="fx-row fx-wrap align-items-stretch justify-content-start  mt-16 mb-16 fx-flex-100">
  <div class="fx-flex-100 border-box">
    <mat-card class="p-0 h-100">
      <div class="p-16">
        <span class="text bold">{{'TRADEMARK.COVERAGE_PRODUCTS_SERVICES' | translate}}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="p-16" *ngIf="case">
        <app-loading-container *ngIf="!documentProductsServices.started || documentProductsServices.loading"
          [height]="200">
        </app-loading-container>
        <app-graph-documents-products-services [data]="documentProductsServices.data"
          [loading]="documentProductsServices.loading" [error]="documentProductsServices.error"
          [noData]="documentProductsServices.started && documentProductsServices.data.length === 0" [title]="false"
          [height]="200" *ngIf="!documentProductsServices.loading"
          [classBalance]="{display:true,classes:case.niceClassification || []}"></app-graph-documents-products-services>
      </div>
    </mat-card>
  </div>
</div>
<div class="fx-row fx-wrap align-items-stretch justify-content-start mt-16 mb-16 fx-flex-100">
  <div class="fx-flex-25 border-box pr-8" *ngIf="case && case.type !== CaseType.RENEWAL_MAINTENANCE">
    <mat-card class="p-0 h-100 fx-column">
      <div class="p-16">
        <span class="text bold">{{'TRADEMARK.COVERAGE_CLASS' | translate}}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="p-16">
        <app-loading-container *ngIf="!documentClasses.started || documentClasses.loading" [height]="200">
        </app-loading-container>
        <app-graph-documents-class [data]="documentClasses.data" [loading]="documentClasses.loading"
          [error]="documentClasses.started && documentClasses.error" [noData]="documentClasses.data.length === 0"
          [title]="false" [height]="200" *ngIf="!documentClasses.loading"></app-graph-documents-class>
      </div>
    </mat-card>
  </div>
  <div class="fx-flex-75 border-box pl-8">
    <mat-card class="p-0 h-100">
      <div class="p-16">
        <span class="text bold">{{'TRADEMARK.COVERAGE_NICE' | translate}}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="p-16" *ngIf="case && case.documents">
        <app-loading-container *ngIf="!documentNice.started || documentNice.loading" [height]="200">
        </app-loading-container>
        <app-graph-documents-nice [data]="documentNice.data" [loading]="documentNice.loading"
          [error]="documentNice.started && documentNice.error" [noData]="documentNice.data.length === 0" [title]="false"
          [height]="200" *ngIf="!documentNice.loading" [count]="case.documents.length"
          [classBalance]="{display:true,classes:case.niceClassification}"></app-graph-documents-nice>
      </div>
    </mat-card>
  </div>
</div>
<div class="fx-row fx-wrap align-items-stretch justify-content-start mt-16 mb-16 fx-flex-100">
  <div class="fx-flex-50 border-box pr-8" *ngIf="case && case.type !== CaseType.RENEWAL_MAINTENANCE">
    <mat-card class="p-0 h-100">
      <div class="p-16">
        <span class="text bold">{{'TRADEMARK.COVERAGE_GEO' | translate}}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="p-16" *ngIf="case && case.documents">
        <app-loading-container *ngIf="!documentTerritories.started || documentTerritories.loading" [height]="300">
        </app-loading-container>
        <app-graph-documents-map [data]="documentTerritories.data" [loading]="documentTerritories.loading"
          [error]="documentTerritories.error"
          [noData]="documentTerritories.started && documentTerritories.data.length === 0" [title]="false" [height]="300"
          *ngIf="!documentTerritories.loading" [count]="case.documents.length"
          [main]="propertyOffice?.code"></app-graph-documents-map>
      </div>
    </mat-card>
  </div>
  <div class="border-box pl-8" [class.fx-flex-50]="case && case.type !== CaseType.RENEWAL_MAINTENANCE"
    [class.fx-flex-100]="case && case.type === CaseType.RENEWAL_MAINTENANCE">
    <mat-card class="p-0 h-100 fx-column">
      <div class="p-16">
        <span class="text bold">{{'TRADEMARK.COVERAGE_TIME' | translate}}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="p-16">
        <app-loading-container *ngIf="!documentPeriods.started || documentPeriods.loading" [height]="300">
        </app-loading-container>
        <app-graph-documents-timeline [data]="documentPeriods.data" [loading]="documentPeriods.loading"
          [error]="documentPeriods.error" [noData]="documentPeriods.started && documentPeriods.data.length === 0"
          [title]="false" [height]="300" *ngIf="!documentPeriods.loading"></app-graph-documents-timeline>
      </div>
    </mat-card>
  </div>
</div>